import React, { useState, useEffect } from "react";
import { InputFieldSm, Label } from "./StyledComp";
// import "./StyledComps.css";

interface IProps {
  id: string;
  value: string;
  isDisabled: boolean;
  label: string;
}

const InputFieldSmallDisabled: React.FC<IProps> = (props) => {
  const handleOnClick = () => {
    console.log(props.id + `clicked`);
  };

  // console.log(memberList[0]["FirstName"]);

  const [isDisabled, setIsDisabled] = useState(false);
  return (
    // <Button className="button" type="submit" onClick={handleOnClick}>
    //   <img className="icon-img" src={props.icon} />
    //   <span className="button-text">{props.buttontext}</span>
    // </Button>
    <div>
      <div className="input-field-sm-div">
        <Label>{props.label}</Label>
        <InputFieldSm
          type="text"
          className="input-field-lg" //"form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          disabled={props.isDisabled}
        />
      </div>
    </div>
  );
};

export default InputFieldSmallDisabled;
